<template>
  <div>
    <TermsFetcher :path="'terms-of-service'" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TermsFetcher from "../terms-fetcher.vue";

@Options({
  title: "E4T: Terms of service",
  components: {
    TermsFetcher,
  },
})
export default class extends Vue {}
</script>

<style lang="scss"></style>
